import connectAsync from '../../../utils/connectAsync';
import DataRequestAuthRoute from './DataRequestAuthRoute';
import { unauthenticateUser } from './../../../actions/auth';

export default connectAsync([unauthenticateUser])(DataRequestAuthRoute);
